export default __webpack_public_path__ + "static/media/newyear2025-tablet-large.3b8e46da.jpg";